export const VisaDisputeReasons = [
    { value: 'NR', ID: 'MERCHANDISESERVICESNOTRECEIVED' },
    { value: 'CR', ID: 'CANCELLEDRECURRINGTRANSACTION' },
    { value: 'ND', ID: 'NOTASDESCRIBED' },
    { value: 'DM', ID: 'DAMAGEDORDEFECTIVEMERCHANDISE' },
    { value: 'Q', ID: 'QUALITY' },
    { value: 'CM', ID: 'COUNTERFEITMERCHANDISE' },
    { value: 'M', ID: 'MISREPRESENTATION' },
    { value: 'CN', ID: 'CREDITNOTPROCESSED' },
    { value: 'CS', ID: 'CANCELLEDMERCHANDISESERVICES' },
    { value: 'OC', ID: 'ORIGINALCREDITNOTACCEPTED' },
    { value: 'CL', ID: 'NONRECEIPTOFCASH' },
    { value: 'TC', ID: 'TERMSOFCONTRACTVIRTUALACCOUNT' },
    { value: 'D', ID: 'DUPLICATE' },
    { value: 'IAN', ID: 'INCORRECTACCOUNTNUMBER' },
    { value: 'IA', ID: 'INCORRECTAMOUNT' },
    { value: 'IC', ID: 'INCORRECTCURRENCY' },
    { value: 'IT', ID: 'INCORRECTTRANSACTIONCODE' },
    { value: 'ID', ID: 'INVALIDDATA' },
    { value: 'LP', ID: 'LATEPRESENTMENT' },
    { value: 'P', ID: 'PAIDBYOTHERMEANS' },
];
